import { Record } from "immutable";

const defaults = {
    __allow_bulk_ordering: false,
    __customer_groups: [],
    __default_discount: 0,
    __default_surcharge: 0,
    __pricing_template: "",
    __warehouses: [],
};

export class Settings extends Record(defaults) {
    declare __allow_bulk_ordering: boolean;
    declare __customer_groups: string[];
    declare __default_discount: number;
    declare __default_surcharge: number;
    declare __pricing_template: string;
    declare __warehouses: string[];

    constructor(args: any = {}) {
        super({
            ...args,
        });
    }
}
